import { render, staticRenderFns } from "./CandidateDocumentInfo.vue?vue&type=template&id=e211a928&scoped=true"
import script from "./CandidateDocumentInfo.vue?vue&type=script&lang=js"
export * from "./CandidateDocumentInfo.vue?vue&type=script&lang=js"
import style0 from "./CandidateDocumentInfo.vue?vue&type=style&index=0&id=e211a928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e211a928",
  null
  
)

export default component.exports